import { configureStore } from '@reduxjs/toolkit'
import deviceReducer from '../store/deviceSlice';
import loadTimeReducer from '../store/loadTimeSlice';
import contentReducer from '../store/contentSlice';
import deliveredContentReducer from '../store/deliveredContentSlice';

export default configureStore({
  reducer: {
    device: deviceReducer,
    loadTime: loadTimeReducer,
    content: contentReducer,
    deliveredContent : deliveredContentReducer
  }
})